export default "__VITE_ASSET__bbaaf650__"